var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHowtoCurl2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 973,
    height: 492,
    viewBox: "0 0 973 492",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 77.4998C31 4.99971 120.122 -23.6506 211.5 30.4997C265.5 62.4998 253.167 385.667 273 414C294.5 468.5 222.5 514 211.5 478C200.5 442 253.667 460 319 453.5C407.333 452.333 599.5 453.5 583 325.5C518.333 233.833 641.8 27.4002 775 7.00021C908.2 -13.3998 964.5 37.6663 971 59.4996",
    stroke: "#256EFB",
    strokeWidth: 4,
    strokeDasharray: "20 20"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowtoCurl2);
export default __webpack_public_path__ + "static/media/howto_curl2.dda75ef2f32fcec6fd964202704c0026.svg";
export { ForwardRef as ReactComponent };